import React, { Component } from "react";
import styles from "./EmailModulePreview.module.css";

export default class EmailModulePreview extends Component {
  render() {
    const { module, accountId } = this.props;
    const { name, id, updatedAt } = module;

    return (
      <div className={styles.module}>
        <div className={styles.name}>{name}</div>
        <div className={styles.preview}>
          <img
            src={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/email-modules/${id}/image?updatedAt=${updatedAt}`}
            alt=""
          />
        </div>
      </div>
    );
  }
}
